import script from "./insureAxDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./insureAxDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./insureAxDispatchDrawer.vue?vue&type=style&index=0&id=c2ca3408&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ca3408"]])

export default __exports__